import { NetworkLogo } from 'gu-ui-kit'
import PropTypes from 'prop-types'
import React from 'react'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import { ROUTES } from 'constants/routes'
import useGeneratePathI18n from 'utils/hooks/useGeneratePathI18n'
import { APP_PRODUCT } from 'constants/app-config'
import { useBreakpoint } from 'utils/hoc/breakpointProvider'
import { IS_APP_PRODUCT_ADSIMPLE } from 'utils/constants/product'

const SIZES = {
  getuniq: {
    full: {
      width: 129,
      height: 44,
    },
    compact: {
      width: 44,
      height: 44,
    },
  },
  adsimple: {
    compact: {
      width: 40,
      height: 40,
    },
    full: {
      width: 140,
      height: 44,
    },
  },
}

const LogoIcon = ({ size = null }) => {
  const breakpoint = useBreakpoint()

  return (
    <NetworkLogo
      name={APP_PRODUCT}
      color={
        breakpoint.fbs && IS_APP_PRODUCT_ADSIMPLE
          ? 'Interface-GU-Primary'
          : 'Interface-Eleven'
      }
      type={breakpoint.fbs ? 'unlinked' : 'component'}
      {...SIZES[APP_PRODUCT][size || breakpoint.fbs ? 'compact' : 'full']}
    />
  )
}

LogoIcon.propTypes = {
  size: PropTypes.string,
}

const Logo = ({ className, width }) => {
  const { i18n, auth } = useSelector(({ app, auth }) => ({
    i18n: app.i18n,
    auth: auth.auth,
  }))
  const pathGen = useGeneratePathI18n()

  return auth ? (
    <Link className={className} to={pathGen(ROUTES.SERVICES)}>
      <LogoIcon width={width} />
    </Link>
  ) : (
    <a href={i18n === 'ru' ? '/' : pathGen(ROUTES.MAIN)}>
      <LogoIcon width={width} />
    </a>
  )
}

Logo.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
}

export default Logo

export { LogoIcon }
